import React from 'react';
import { AlertCircle, Monitor, Users, RefreshCw } from 'lucide-react';

export const Problem = () => {
  const problems = [
    {
      icon: <Monitor size={32} />,
      title: 'Viel Sitzen & Bildschirmarbeit',
      description: 'Stundenlang am Schreibtisch, der Körper meldet sich mit Schmerzen.'
    },
    {
      icon: <AlertCircle size={32} />,
      title: 'Rückenschmerzen & Verspannungen',
      description: 'Nackenverspannungen, Rückenschmerzen und ständige Müdigkeit begleiten deinen Alltag.'
    },
    {
      icon: <RefreshCw size={32} />,
      title: 'Programme ohne Erfolg',
      description: 'Du hast schon vieles ausprobiert, aber die Schmerzen kommen immer wieder zurück.'
    },
    {
      icon: <Users size={32} />,
      title: '"Das ist normal"',
      description: 'Du denkst "Das ist das Alter" oder "Alle haben das" – aber das muss nicht sein.'
    }
  ];

  return (
    <section style={{
      padding: 'var(--spacing-giant) 0',
      background: 'var(--bg-subtle)'
    }}>
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: 'var(--spacing-xl)' }}>
          <h2 className="display-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Kommt dir das bekannt vor?
          </h2>
          <p className="body-large" style={{ maxWidth: '700px', margin: '0 auto' }}>
            Dein Problem ist nicht, DASS du dich zu wenig bewegst – sondern WIE du dich bewegst.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: 'var(--spacing-large)',
          marginTop: 'var(--spacing-xl)'
        }}>
          {problems.map((problem, index) => (
            <div key={index} className="network-card" style={{
              textAlign: 'center',
              cursor: 'default'
            }}>
              <div style={{
                color: 'var(--brand-dark)',
                marginBottom: 'var(--spacing-medium)',
                display: 'flex',
                justifyContent: 'center'
              }}>
                {problem.icon}
              </div>
              <h3 className="heading-3" style={{ marginBottom: 'var(--spacing-small)' }}>
                {problem.title}
              </h3>
              <p className="body-medium">
                {problem.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};